:root {
  --arrow-size: 40px;
  --arrow-hover-opacity: 0.8;
  --transition-duration: 250ms;
  --transition-timing: ease;
  --fade-width: 20px;
  --fade-start: 0;
  --fade-end: var(--fade-width);
  --fade-in: transparent 0, black var(--fade-width);
  --fade-out: black calc(100% - var(--fade-width)), transparent 100%;
}

@media (min-width: 768px) {
  :root {
    --fade-width: 49px;
    --fade-start: 41px;
    --fade-end: calc(var(--fade-start) + var(--fade-width));
    --fade-in: transparent var(--fade-start), black var(--fade-end);
    --fade-out: black calc(100% - var(--fade-end)), transparent calc(100% - var(--fade-start));
  }
}

.scrollableContainer {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.scrollableRow {
  display: flex;
  gap: var(--cxy-spacing-xxsm);
  width: 100%;
  overflow-x: scroll;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  transition:
    mask-image var(--transition-duration) var(--transition-timing),
    -webkit-mask-image var(--transition-duration) var(--transition-timing);
}

.arrow {
  position: absolute;
  z-index: var(--cxy-z-index-internal-mid);
  width: var(--arrow-size);
  height: var(--arrow-size);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--cxy-color-content-on-inverse);
  color: var(--cxy-color-icon-black);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity var(--transition-duration) var(--transition-timing),
    visibility 0s linear var(--transition-duration);

  &:hover:not(:disabled) {
    opacity: var(--arrow-hover-opacity);
  }
}

[data-fpsm-theme='whoscored'] .arrow {
  background: var(--cxy-color-surface-page);
}

.leftArrow {
  left: 0;
  display: none;
}

.rightArrow {
  right: 0;
  display: none;
}

.showLeftFade .leftArrow,
.showRightFade .rightArrow {
  opacity: 0;
  visibility: hidden;
}

@media (min-width: 768px) {
  .leftArrow,
  .rightArrow {
    display: flex;
  }

  .showLeftFade .leftArrow,
  .showRightFade .rightArrow {
    opacity: 1;
    visibility: visible;
    transition:
      opacity var(--transition-duration) var(--transition-timing),
      visibility 0s;

    &:hover:not(:disabled) {
      opacity: var(--arrow-hover-opacity);
    }
  }
}

.showLeftFade .scrollableRow,
.showRightFade .scrollableRow {
  -webkit-mask-image: linear-gradient(to right, var(--fade-in), var(--fade-out));
  mask-image: linear-gradient(to right, var(--fade-in), var(--fade-out));
}

.showLeftFade:not(.showRightFade) .scrollableRow {
  -webkit-mask-image: linear-gradient(to right, var(--fade-in), black 100%);
  mask-image: linear-gradient(to right, var(--fade-in), black 100%);
}

.showRightFade:not(.showLeftFade) .scrollableRow {
  -webkit-mask-image: linear-gradient(to right, black 0, var(--fade-out));
  mask-image: linear-gradient(to right, black 0, var(--fade-out));
}

.noArrows.showLeftFade .scrollableRow,
.noArrows.showRightFade .scrollableRow {
  --fade-start: 0;
  --fade-end: var(--fade-width);
  --fade-in: transparent 0, var(--cxy-color-icon-black) var(--fade-width);
  --fade-out: var(--cxy-color-icon-black) calc(100% - var(--fade-width)), transparent 100%;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .arrow {
    background-color: var(--cxy-color-surface-secondary-default-subtle);

    > svg {
      stroke: var(--cxy-color-content-on-inverse);
    }
  }
}
